var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvoiceApproval = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M5.172-22H21.584a1.172,1.172,0,0,1,1.172,1.172V.268A1.172,1.172,0,0,1,21.584,1.44H5.172A1.172,1.172,0,0,1,4,.268v-21.1A1.172,1.172,0,0,1,5.172-22Z",
  transform: "translate(-4 22)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M7-18v1.172h5.86V-18Z",
  transform: "translate(-7 18)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M7-12v1.172H18.72V-12Z",
  transform: "translate(-7 12)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M7-15v1.172h4.688V-15Z",
  transform: "translate(-7 15)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M7-9v1.172h9.376V-9Z",
  transform: "translate(-7 9)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M7-6v1.172h7.032V-6Z",
  transform: "translate(-7 6)",
  fill: "#fff"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(42 -3209)"
}, /*#__PURE__*/React.createElement("g", {
  id: "promotion1",
  transform: "translate(-78 397)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ANALYST_CONFIGURATION",
  transform: "translate(443 1255)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 34,
  height: 34,
  transform: "translate(-407 1557)",
  fill: "#cc6969",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_32",
  "data-name": "Group 32",
  transform: "translate(-835.362 -1299.747)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(428.997 2866.001)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M1.172,0H17.584a1.172,1.172,0,0,1,1.172,1.172v21.1a1.172,1.172,0,0,1-1.172,1.172H1.172A1.172,1.172,0,0,1,0,22.268V1.172A1.172,1.172,0,0,1,1.172,0Z",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(432.514 2870.689)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M2-23H19.584v12.892H2Z",
  transform: "translate(-7.861 17.139)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(432.514 2877.72)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M2-17H25.444V-4.108H2Z",
  transform: "translate(-7.861 11.139)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(432.514 2874.204)",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M2-20H18.411V-7.108H2Z",
  transform: "translate(-7.861 14.139)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_98",
  "data-name": "Group 98",
  transform: "translate(432.514 2881.237)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M2-14H23.1V-1.108H2Z",
  transform: "translate(-7.861 8.139)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_99",
  "data-name": "Group 99",
  transform: "translate(432.514 2884.753)",
  clipPath: "url(#clip-path-6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M2-11H20.756V1.892H2Z",
  transform: "translate(-7.861 5.139)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(440.131 2870.102)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M2.817,4.063a.591.591,0,0,0-.244-.478,2.369,2.369,0,0,0-.82-.352A2.839,2.839,0,0,1,.581,2.71a1.041,1.041,0,0,1-.368-.82,1.065,1.065,0,0,1,.359-.829A1.688,1.688,0,0,1,1.563.676V0h.563V.679a1.568,1.568,0,0,1,.988.435,1.37,1.37,0,0,1,.352,1H2.771a.938.938,0,0,0-.253-.69.918.918,0,0,0-.684-.256,1.082,1.082,0,0,0-.687.19A.639.639,0,0,0,.91,1.88a.593.593,0,0,0,.251.5,2.538,2.538,0,0,0,.827.339,3.879,3.879,0,0,1,.9.336,1.306,1.306,0,0,1,.476.427,1.051,1.051,0,0,1,.152.572,1.036,1.036,0,0,1-.383.839,1.9,1.9,0,0,1-1.074.379V5.86H1.5V5.274a1.8,1.8,0,0,1-1.1-.41A1.231,1.231,0,0,1,0,3.9H.7a.813.813,0,0,0,.276.66,1.184,1.184,0,0,0,.783.231,1.359,1.359,0,0,0,.778-.195.611.611,0,0,0,.282-.53Z",
  transform: "translate(0.002)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(-22.02 3210)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.429,
  cy: 6.429,
  r: 6.429,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.429,
  cy: 6.429,
  r: 5.679,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-check",
  "data-name": "Icon awesome-check",
  d: "M2.446,9.842.105,7.5a.36.36,0,0,1,0-.509l.509-.509a.36.36,0,0,1,.509,0L2.7,8.059,6.077,4.683a.36.36,0,0,1,.509,0l.509.509a.36.36,0,0,1,0,.509L2.955,9.842A.36.36,0,0,1,2.446,9.842Z",
  transform: "translate(2.828 -0.833)",
  fill: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvoiceApproval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/invoice_approval.bcc03ff73c7046123cabc49f53e0b521.svg";